import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-21f1d4d3")

_pushScopeId("data-v-21f1d4d3")
const _hoisted_1 = { class: "flex flex-wrap lg:-mx-2 text-xs" }
const _hoisted_2 = { class: "w-full lg:w-1/2 lg:px-2 mb-2" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, "blur", -1)
const _hoisted_4 = { class: "w-full lg:w-1/2 lg:px-2 mb-2" }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, "brightness", -1)
const _hoisted_6 = { class: "w-full lg:w-1/2 lg:px-2 mb-2" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", null, "contrast", -1)
const _hoisted_8 = { class: "w-full lg:w-1/2 lg:px-2 mb-2" }
const _hoisted_9 = /*#__PURE__*/_createVNode("p", null, "drop-shadow", -1)
const _hoisted_10 = { class: "w-full lg:w-1/2 lg:px-2 mb-2" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", null, "grayscale", -1)
const _hoisted_12 = { class: "w-full lg:w-1/2 lg:px-2 mb-2" }
const _hoisted_13 = /*#__PURE__*/_createVNode("p", null, "hue-rotate", -1)
const _hoisted_14 = { class: "w-full lg:w-1/2 lg:px-2 mb-2" }
const _hoisted_15 = /*#__PURE__*/_createVNode("p", null, "invert", -1)
const _hoisted_16 = { class: "w-full lg:w-1/2 lg:px-2 mb-2" }
const _hoisted_17 = /*#__PURE__*/_createVNode("p", null, "opacity", -1)
const _hoisted_18 = { class: "w-full lg:w-1/2 lg:px-2 mb-2" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", null, "saturate", -1)
const _hoisted_20 = { class: "w-full lg:w-1/2 lg:px-2 mb-2" }
const _hoisted_21 = /*#__PURE__*/_createVNode("p", null, "sepia", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ExampleImage = _resolveComponent("ExampleImage")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_ExampleImage, { class: "bg-cover demo blur" }),
      _hoisted_3
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_ExampleImage, { class: "bg-cover demo brightness" }),
      _hoisted_5
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_ExampleImage, { class: "bg-cover demo contrast" }),
      _hoisted_7
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode(_component_ExampleImage, { class: "bg-cover demo drop-shadow" }),
      _hoisted_9
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode(_component_ExampleImage, { class: "bg-cover demo grayscale" }),
      _hoisted_11
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode(_component_ExampleImage, { class: "bg-cover demo hue-rotate" }),
      _hoisted_13
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode(_component_ExampleImage, { class: "bg-cover demo invert" }),
      _hoisted_15
    ]),
    _createVNode("div", _hoisted_16, [
      _createVNode(_component_ExampleImage, { class: "bg-cover demo opacity" }),
      _hoisted_17
    ]),
    _createVNode("div", _hoisted_18, [
      _createVNode(_component_ExampleImage, { class: "bg-cover demo saturate" }),
      _hoisted_19
    ]),
    _createVNode("div", _hoisted_20, [
      _createVNode(_component_ExampleImage, { class: "bg-cover demo sepia" }),
      _hoisted_21
    ])
  ]))
})